export default __webpack_public_path__ + "static/10_Screenshot-d38f3df942d666d217509a82956ce96b.png";